module.exports = __webpack_public_path__ + "img/index_img2.d49ae2f6.png";